"use strict";

define('components/preview_watermark_utils',['components/ajax', 'components/form'], function(ajax, form) {
    var previewWatermarkUtils = {
        // Configurable defaults that can be overridden
        defaults: {
            modalId: 'preview-pdf-modal',
            modalBodyHeight: '80vh',
            spinnerPath: '/static/spinner_lg.gif'
        },

        createPreviewModal: function(result, options) {
            var modalId = (options && options.modalId) || this.defaults.modalId;

            var modalContent =
                '<div class="modal fade in" id="' + modalId + '" tabindex="-1" role="dialog" style="display: none;">' +
                    '<div class="modal-dialog modal-lg" data-cy="preview-modal-watermark-add-edit">' +
                        '<div class="modal-content">' +
                            result +
                        '</div>' +
                    '</div>' +
                '</div>';

            // Remove existing modal if present
            $('#' + modalId).remove();

            var modalDiv = $(modalContent);
            $('body').append(modalDiv)
            modalDiv.css('display', 'block');

            var modalBody = document.querySelector('#' + modalId + ' .modal-body');
            modalBody.style.height = options.modalBodyHeight || this.defaults.modalBodyHeight;

            return modalDiv;
        },

        setupModalClose: function(modalDiv, callbacks) {
            var closeModal = function() {
                if (callbacks.onClose) {
                    callbacks.onClose();
                }
                modalDiv.css('display', 'none');
                modalDiv.remove();
                $('#custom-backdrop').remove();
            };

            modalDiv.on('click', '.close', closeModal);

            var buttons = modalDiv.find('button');
            buttons.each(function() {
                if ($(this).text().trim() === 'Close') {
                    $(this).on('click', closeModal);
                }
            });

            // Close when clicking outside the modal (on the backdrop)
            $(document).on('click', function(event) {
                if ($(event.target).closest('.modal-content').length === 0 && $(event.target).closest('.modal').length !== 0) {
                    closeModal();
                }
            });
        },

        handlePreview: function(config) {
            var self = this;
            var formData = config.formData;

            // Append CSRF token if not present
            if (!formData.has('csrf_token')) {
                formData.append('csrf_token', $('meta[name=csrf_token]').attr('content'));
            }

            // Pre-preview setup
            if (config.beforePreview) {
                config.beforePreview();
            }

            function extractIdFromUrl(url) {
                var match = url.match(/\/document_watermarks\/(\d+)\/preview_draft$/);
                return match ? match[1] : null;
            }

            $.ajax({
                url: config.previewUrl,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function(result) {
                    if (result.status !== "error") {
                        var modalDiv = self.createPreviewModal(result, config.modalOptions);

                        var id = extractIdFromUrl(config.previewUrl);
                        var hasId = id !== null;
                        if (hasId) {
                            var customBackdrop = $('<div id="custom-backdrop" class="modal-backdrop fade in"></div>');
                            $('body').append(customBackdrop);
                        }

                        self.setupModalClose(modalDiv, {
                            onClose: function() {
                                if (config.onModalClose) {
                                    config.onModalClose();
                                }
                            }
                        });

                        if (config.onPreviewSuccess) {
                            config.onPreviewSuccess(result);
                        }
                    } else {
                        if (config.onPreviewFailure) {
                            config.onPreviewFailure(result);
                        }
                    }
                },
                error: function(result) {
                    if (config.onPreviewError) {
                        config.onPreviewError(result);
                    }
                }
            });
        }
    };

    return previewWatermarkUtils;
});

